import type { ReactElement } from 'react'
import { phoneDialString } from '~/utils/phone'

export const renderPhoneLink = (
  phone?: string | null
): ReactElement | string | null => {
  if (phone == null || phone.trim() === '') {
    return phone ?? null
  }

  return <a href={phoneDialString(phone)}>{phone}</a>
}
